// extracted by mini-css-extract-plugin
module.exports = {"root":"az_a9b","certonaPartCard":"az_b9b","svgForOos":"az_c9b"};